import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';

function Pendingreport() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });
    const printRef = useRef();
    const [loading, setloading] = useState(false);
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const [fromDate, setfromDate] = useState("");
    const [toDate, settoDate] = useState("");
    const [username, setusername] = useState("");
    const [bookingData, setbookingData] = useState([]);
    const [payhistory, setpayhistory] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [totalamount, settotalamount] = useState(0);
    const [paid, setpaid] = useState(0);
    const [remaining, setremaining] = useState(0);
    const [noofrooms, setnoofrooms] = useState(0);
    const [noofadults, setnoofadults] = useState(0);

    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        setloadincount(false)
                    }

                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    const getReport = async () => {

        if (!fromDate || !toDate) {
            Toast.fire({ icon: "error", title: 'Please select From Date & To Date' });
            return
        }

        setloading(false)
        setbookingData([])
        setpaymodes([])
        setpayhistory([])
        const today = new Date(fromDate);
        today.setHours(0, 0, 0, 0);

        const tomorrow = new Date(toDate);
        tomorrow.setDate(tomorrow.getDate() + 1);

        const q = query(collection(db, 'bookings'), where('status', '!=', 'Canceled'), where('remaining', '>', 0), where('createdAt', '>=', Timestamp.fromDate(today)), where('createdAt', '<', Timestamp.fromDate(tomorrow)));
        onSnapshot(q, (querySnapshot) => {
            setbookingData(querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })));
        });
        const querySnapshot = await getDocs(q);
        const total = querySnapshot.docs.reduce((sum, doc) => sum + (doc.data().totalamount || 0), 0);
        const paid = querySnapshot.docs.reduce((sum, doc) => sum + (doc.data().advance || 0), 0);
        const pending = querySnapshot.docs.reduce((sum, doc) => sum + (doc.data().remaining || 0), 0);
        const noofperson = querySnapshot.docs.reduce((sum, doc) => sum + (parseFloat(doc.data().adults) || 0), 0);
        const noofrooms = querySnapshot.docs.reduce((sum, doc) => sum + (parseFloat(doc.data().rooms.length) || 0), 0);

        settotalamount(total.toFixed(0));
        setpaid(paid.toFixed(0));
        setremaining(pending.toFixed(0));
        setnoofadults(noofperson);
        setnoofrooms(noofrooms);

        setloading(true)
    }

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })

    const handleFromDate = (e) => {
        setfromDate(e.target.value)
        setloading(false)
    }
    const handleToDate = (e) => {
        settoDate(e.target.value)
        setloading(false)
    }

    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " >|| All Pending Report ||</button><br /><br />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label>From Date</label>
                                                <input type='date' value={fromDate} onChange={handleFromDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-4'>
                                                <label>To Date</label>
                                                <input type='date' value={toDate} onChange={handleToDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-3'>
                                                <br />
                                                <button className='btn btn-info' onClick={getReport}>Get Report</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    loading &&
                                    <>
                                        <div className="card card-primary card-outline" ref={printRef}>
                                            <div className="card-body">
                                                <div className="row invoice-info">
                                                    <div className="col-sm-12 invoice-col text-center">
                                                        <address>
                                                            <h4>Dasara Executive</h4>
                                                            Chatrapati Shivaji Maharaj Chouk, Tuljapur, Dist - Dharashiv, MH - 413601<br />
                                                            Phone: +91 9975294940 |
                                                            Email:  dasaraexecutive@gmail.com<br />
                                                            Website:  www.dasaraexecutive.com
                                                        </address>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <table className='customers '>
                                                        <tr>
                                                            <th style={{ textAlign: "center" }}>From Date : {moment(fromDate).format('DD/MM/YYYY')}  </th>
                                                            <th style={{ textAlign: "center" }}><h5>PENDING REPORT </h5></th>
                                                            <th style={{ textAlign: "center" }}>To Date : {moment(toDate).format('DD/MM/YYYY')}</th>
                                                        </tr>
                                                    </table>
                                                    <table className="customers">
                                                        <thead>
                                                            <tr>
                                                                <th>Sr No</th>
                                                                <th>Customer Name </th>
                                                                <th>Mobile </th>
                                                                <th>Checkin Date </th>
                                                                <th>Checkout Date </th>
                                                                <th>No Of Day </th>
                                                                <th>Rooms </th>
                                                                <th>Adults </th>
                                                                {/* <th>Childs </th> */}
                                                                <th style={{ textAlign: "right" }}>Total</th>
                                                                <th style={{ textAlign: "right" }}>Paid</th>
                                                                <th style={{ textAlign: "right" }}>Pending</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                bookingData.map((item, num = 1) => {
                                                                    return (
                                                                        <tr key={num + 1}>
                                                                            <td width="80">{num + 1}</td>
                                                                            <td style={{ textTransform: "capitalize" }}>
                                                                                {item.data.customers.custname}
                                                                                {
                                                                                    item.data.status === 'Canceled' &&
                                                                                    <span style={{ color: "red", fontWeight: "bold" }}>Canceled</span>
                                                                                }
                                                                            </td>
                                                                            <td>{item.data.customers.mobile} </td>
                                                                            <td>{moment(item.data.checkindate).format('DD/MM/YYYY')} {item.data.checkintime}</td>
                                                                            <td>{moment(item.data.checkoutdate).format('DD/MM/YYYY')} {item.data.checkouttime}</td>
                                                                            <td>{item.data.noofdays} Days</td>
                                                                            <td>
                                                                                {item.data.rooms.map((item1, index) =>
                                                                                    <span key={index}>&nbsp;{item1.roomname} <br />  </span>
                                                                                )}
                                                                            </td>
                                                                            <td>{item.data.adults} Persons</td>
                                                                            {/* <td>{item.data.childs} Childs</td> */}
                                                                            <td style={{ textAlign: "right" }}>{item.data.totalamount.toFixed(0)}</td>
                                                                            <td style={{ textAlign: "right" }}>{item.data.advance.toFixed(0)}</td>
                                                                            <td style={{ textAlign: "right" }}>{item.data.remaining.toFixed(0)}</td>
                                                                        </tr>
                                                                    )
                                                                }

                                                                )}
                                                            <tr>
                                                                <td><b>Total</b></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td><b>{noofrooms} Rooms</b></td>
                                                                <td><b>{noofadults} Persons</b></td>
                                                                <td style={{ textAlign: "right" }}><b>{totalamount}</b></td>
                                                                <td style={{ textAlign: "right" }}><b>{paid}</b></td>
                                                                <td style={{ textAlign: "right" }}><b>{remaining}</b></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    {/* <table className='customers'>
                                                        <thead>
                                                            <tr>
                                                                <th> <span> Booking Amount :  Rs. {total} /- </span></th>
                                                            </tr>
                                                            <tr>
                                                                <th> <span> Paid Amount :  Rs. {total} /- </span></th>
                                                            </tr>
                                                            <tr>
                                                                <th> <span> Pending Amount :  Rs. {total} /- </span></th>
                                                            </tr>
                                                        </thead>
                                                    </table> */}
                                                    {/* <table className="customers">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ backgroundColor: "#E0FCFE" }} colSpan={10}>Collection Reports</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Paymode 1</th>
                                                                <th>Amount 1</th>
                                                                <th>Paytime 1</th>
                                                                <th>Paymode 2</th>
                                                                <th>Amount 2</th>
                                                                <th>Paytime 2</th>
                                                                <th>Datetime</th>
                                                                <th>Note</th>
                                                                <th>Username</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                payhistory.map((item, index) =>
                                                                    <tr key={index}>
                                                                        <td>{item.paymode1}</td>
                                                                        <td>{item.data.amount1}</td>
                                                                        <td>{item.data.paytime1}</td>
                                                                        <td>{item.paymode2}</td>
                                                                        <td>{item.data.amount2}</td>
                                                                        <td>{item.data.paytime2}</td>
                                                                        <td>{item.createdat}</td>
                                                                        <td>{item.data.note}</td>
                                                                        <td>{item.data.username}</td>
                                                                    </tr>
                                                                )
                                                            }
                                                        </tbody>
                                                    </table> */}
                                                    {/* <table className='customers'>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ backgroundColor: "#E0FCFE" }} colSpan={paymodes.length + 1}>Paymode Wise Collection</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Paymodes</th>
                                                                {
                                                                    paymodes.map((item, index) =>
                                                                        <th key={index}>{item.paymode}</th>
                                                                    )
                                                                }
                                                            </tr>
                                                            <tr>
                                                                <th>Amount</th>
                                                                {
                                                                    paymodes.map((item, index) =>
                                                                        <td key={index}>{item.totalamount}</td>
                                                                    )
                                                                }
                                                            </tr>
                                                        </thead>
                                                    </table><br />
                                                    <table className='customers'>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ backgroundColor: "#E0FCFE" }}> <h6> Total Collection of {username} :  Rs. {total} /- </h6></th>
                                                            </tr>
                                                        </thead>
                                                    </table> */}
                                                </div>
                                            </div>

                                        </div>
                                        <center>
                                            <button className='btn btn-success' onClick={handlePrint}>Print Report</button>
                                        </center>
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                </section >




            </div>



        </div >

    )
}

export default Pendingreport
